module.exports = __webpack_public_path__ + "img/thunderstorm.7e644c1a.svg";